<template>
  <section class="overview" v-if="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        class="mt-3"
        :available-workshops="lessonCount"
        :active-children="childrenCount"
      />
      <parent-children-graph-average
        v-for="(childReportData, id) in parentChildrenGraphData"
        :child-id="id"
        :child-report-data="childReportData"
        :key="`parent-children-${id}`"
      />
      <!-- <notifications type="parents" /> -->
      <lessons-table />
    </v-container>
  </section>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import Auth from '@/modules/auth/models/Auth'
// import Notifications from '@/components/notification/overview/Notifications'
import LessonsTable from '@/modules/auth/views/dashboard/LessonsTable'
import { mapState } from 'vuex'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'
import Parent from '@/modules/parent/models/Parent'
import Individual from '@/modules/individual/models/Individual'
import ParentChildrenGraphAverage from './overview/ParentChildrenGraphAverage'

export default {
  name: 'Overview',
  components: {
    // Notifications,
    LessonsTable,
    OverviewCard,
    ParentChildrenGraphAverage
  },
  data() {
    return {
      ready: false,
      parentChildrenGraphData: []
    }
  },
  computed: {
    me() {
      return Auth.query()
        .where('type', 'parent')
        .first()
    },
    lessonCount() {
      return Lesson.query().count()
    },
    childrenCount() {
      return Individual.all().length
    },
    children() {
      return Individual.all()
    },
    ...mapState(['bucketUrl'])
  },
  async mounted() {
    this.$store.state.loading = true
    await Lesson.dispatch('fetch', this.$route.meta.type)
    await Parent.dispatch('getChildren')
    this.parentChildrenGraphData = await this.$axios.get(
      '/api/parents/reports?type=quizResultChildrenWithGlobalAverage&date_start=2019-01-01&date_end=2019-01-01'
    )

    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {}
}
</script>

<style lang="scss">
.overview {
}
</style>
